import { Button, DropdownTemp } from '../../../../components';
import { useLmsLocation, useLmsOnHandReport } from '../../hooks';
import { lmsFileTypes } from '../../constants';
import Loading from '../Loading';
import RadioButton from '../RadioButton';

interface Props {
  isAdmin: boolean;
}

export default function LmsOnHandReportFilters({ isAdmin }: Props) {
  const { lmsLocationList } = useLmsLocation(isAdmin);

  const {
    isLoading,
    locationCode,
    onChangeLocationCode,
    destinationCode,
    onChangeDestinationCode,
    fileType,
    onChangeFileType,
    clearFilters,
    onClickDownload,
  } = useLmsOnHandReport(isAdmin);

  return (
    <div className='d-flex flex-column gap-4'>
      {isLoading ? <Loading /> : ''}
      <DropdownTemp
        id='lms-location-dropdown'
        options={lmsLocationList}
        value={locationCode}
        setValue={onChangeLocationCode}
        label='Location'
        dummyOptionText='All locations'
        required
      />
      <DropdownTemp
        id='lms-location-destination-dropdown'
        options={lmsLocationList}
        value={destinationCode}
        setValue={onChangeDestinationCode}
        label='Destination'
        dummyOptionText='All locations'
      />
      <RadioButton
        name='fileType'
        label='Report Format'
        selectedValue={fileType}
        setSelectedValue={onChangeFileType}
        radioOptions={lmsFileTypes}
      />
      <div className='d-flex flex-column gap-2 align-items-center pt-4'>
        <Button
          text='Download'
          onClick={onClickDownload}
          disabled={isLoading}
        />
        <Button
          text='Clear'
          onClick={clearFilters}
          disabled={isLoading}
        />
      </div>
    </div>
  );
}
